import { TelegramPanelView } from "./telegram-panel-view";
import type { TelegramSettingsController, TelegramSettingsSnapshot } from "./use-telegram-settings";

/**
 * Блок настроек Telegram §6.6 (design.md решение 8, макет
 * `TelegramPanel.dc.html`) в окне из меню пользователя (stage8-sidebar-layout,
 * решение 3). Контроллер `use-telegram-settings.ts` живёт в каркасе —
 * экран алертов и окно видят одно состояние, — а здесь только проброс его
 * снимка и действий в чистую разметку `TelegramPanelView`.
 */
export interface TelegramPanelProps {
  snapshot: TelegramSettingsSnapshot;
  controller: TelegramSettingsController;
}

export function TelegramPanel({ snapshot, controller }: TelegramPanelProps) {
  return (
    <TelegramPanelView
      snapshot={snapshot}
      onRetry={controller.retry}
      onTokenChange={controller.setToken}
      onStartReplace={controller.startReplace}
      onCancelReplace={controller.cancelReplace}
      onChatIdChange={controller.setChatId}
      onIntervalChange={controller.setInterval}
      onDiscard={controller.discardDraft}
      onSave={controller.save}
      onTest={controller.test}
      onRequestDisconnect={controller.requestDisconnect}
      onCancelDisconnect={controller.cancelDisconnect}
      onConfirmDisconnect={controller.confirmDisconnect}
    />
  );
}
